import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

/**
 * Charge les feature flags actifs pour l'utilisateur connecté.
 * Renvoie un Set<string> pour des lookups O(1).
 */
export function useFeatureFlags() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["feature-flags", user?.id],
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<Set<string>> => {
      const { data, error } = await supabase
        .from("feature_flags")
        .select("flag")
        .eq("user_id", user!.id);
      if (error) {
        console.error("useFeatureFlags error:", error);
        return new Set<string>();
      }
      return new Set((data ?? []).map((r: any) => r.flag as string));
    },
  });
}

export function useHasFeature(flag: string): boolean {
  const { data } = useFeatureFlags();
  return data?.has(flag) ?? false;
}
